import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Card, Input, IconButton, Chip } from "@material-tailwind/react";
import { Search, Sort, Download, Plus, User } from "iconoir-react";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { getMoneyFormat, } from "../../../../utils/formatViews";
import AppImages from "../../../../assets/AppImages";
import Loader from "../../../../components/Loader";
import { RootState } from "../../../../redux";
import { TaskDetailsSidePanel } from "../../../../components/DashboardTaskSidePanel";
import { Task,  updateTasksRequest, listTasksRequest } from "../../../../redux/tasks/actions";
import { listPartsRequest } from "../../../../redux/parts/actions";
import { Employee } from "../../../../redux/employee/actions";
import { Vehicle, updateVehicleSuccess, } from "../../../../redux/vehicles/actions";
import { getTaskStatus, getTaskStatusColor } from "../../../../utils/formatViews";

const TABLE_HEAD = [
    { n: "Task Name", className: "" },
    { n: "Status", className: "w-20" },
    { n: "Hours", className: "w-20" },
    { n: "Payout", className: "w-20" },
    { n: "Employee", className: "w-32 !text-center" },
    { n: "Due Date", className: "w-32" },
    { n: "", className: "w-12" },
];


export function DashboardVehicleInventoryTabWork() {
    const dispatch = useDispatch();
    const { tasks } = useSelector((state: RootState) => state.tasks);
    const { vehicle } = useSelector((state: RootState) => state.vehicles);
    const { auth } = useSelector((state: RootState) => state.auth);
    const [expandedRow, setExpandedRow] = useState<number | null>(null);
    const [selectedTask, setSelectedTask] = useState<Task | null>(null);

    useEffect(() => {
        if (vehicle?.id) {
            dispatch(listPartsRequest({
                filters: `vehicle_id:null||vehicle_id:${vehicle.id}`,
                part_fields: "",
                excludes: "",
                save_as: 'parts_tasks',
            }));
        }
    }, [dispatch, vehicle]);

    useEffect(() => {
        if (vehicle) {
            dispatch(listTasksRequest({
                filters: "",
                task_fields: "",
                excludes: "",
                vehicle_id: vehicle?.id
            }));
        }
    }, [dispatch, vehicle]);

    const renderRow = (task: Task, idx: number, className?: string) => {
        return (
            <React.Fragment key={idx}>
                <tr
                    className="h-20"
                    onClick={() => {
                        if (["SuperUser", "Admin"].includes(auth?.user?.role?.title || "")) {
                            if (selectedTask) {
                                setSelectedTask(null);
                            } else {
                                setSelectedTask(task);
                            }
                        }
                    }}
                >
                    <td className={`p-4 border-b border-surface ${className ?? ""}`}>
                        <div className="flex gap-x-3 items-center ">
                            {task.subtasks && task.subtasks.length > 0 && (
                                <button
                                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                        if (e) {
                                            e.stopPropagation();
                                            e.preventDefault();
                                        }
                                        setExpandedRow(expandedRow === idx ? null : idx);
                                    }}
                                    className="text-primary focus:outline-none"
                                >
                                    <AppImages.iconChevronRight
                                        className={`h-4 w-4 transform transition-transform ${
                                            expandedRow === idx ? "rotate-90" : ""
                                        }`}
                                    />
                                </button>
                            )}
                            <Button
                                variant="ghost"
                                color="secondary"
                                size="sm"
                                className="p-0"
                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                    if (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }
                                    dispatch(
                                        updateTasksRequest({
                                            vehicle_id: vehicle?.id,
                                            tasks: tasks.map((t) =>
                                                t.id === task.id
                                                    ? { ...t, is_complete: !t.is_complete }
                                                    : t
                                            ),
                                            update_fields: ["id", "is_complete"],
                                            cb: (data: Task[]) => {
                                                dispatch(
                                                    updateVehicleSuccess({
                                                        ...vehicle,
                                                        tasks: data,
                                                    } as Vehicle)
                                                );
                                            },
                                        })
                                    );
                                }}
                            >
                                {task.is_complete ? (
                                    <AppImages.iconBadgeCheck className="h-6 w-6 text-bold text-success" />
                                ) : (
                                    <AppImages.iconBadgeUncheck className="h-6 w-6 text-bold text-secondary" />
                                )}
                            </Button>
                            <Typography
                                color="primary"
                                className="block font-bold cursor-pointer flex-grow"
                            >
                                {task.name}
                            </Typography>
                        </div>
                    </td>
                    <td className="p-4 border-b border-surface">
                        <Chip
                            size="sm"
                            isPill={false}
                            className="w-max"
                            color={getTaskStatusColor(task)}
                        >
                            <Chip.Label>{getTaskStatus(task)}</Chip.Label>
                        </Chip>
                    </td>
                    <td className="p-4 border-b border-surface">
                        <Typography type="small" className="block text-foreground">
                            {task.hours}
                        </Typography>
                    </td>
                    <td className="p-4 border-b border-surface">
                        <Typography type="small" className="block text-foreground">
                            {getMoneyFormat(task.payout)}
                        </Typography>
                    </td>
                    <td className="p-4 border-b border-surface">
                        <div className="flex items-center justify-center -space-x-3">
                            {task.assignees?.map((e: Employee, key: number) => (
                                <React.Fragment key={key}>
                                    {e?.avatar ? (
                                        <div className="flex items-center justify-center w-7 h-7 bg-gray-200 rounded-full">
                                            <img src={e?.avatar} className="h-5 w-5" />
                                        </div>
                                    ) : (
                                        <div className="flex items-center justify-center w-7 h-7 bg-gray-200 rounded-full">
                                            <User className="h-5 w-5" />
                                        </div>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </td>
                    <td className="p-4 border-b border-surface">
                        <Typography type="small" className="block text-foreground">
                            {task.due_date}
                        </Typography>
                    </td>
                    <td className="p-4 border-b border-surface">
                        {["SuperUser", "Admin"].includes(auth?.user?.role?.title || "") && (
                            <IconButton
                                variant="ghost"
                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                    if (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }

                                    withReactContent(Swal)
                                        .fire({
                                            title: "Are you sure?",
                                            text: "You won't be able to revert this!",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#3085d6",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText: "Yes, delete it!",
                                        })
                                        .then((result) => {
                                            if (result.isConfirmed) {
                                                dispatch(
                                                    updateTasksRequest({
                                                        vehicle_id: vehicle?.id,
                                                        tasks: tasks.map((t) =>
                                                            t.id === task.id
                                                                ? { ...t, is_removed: true }
                                                                : t
                                                        ),
                                                        update_fields: ["id", "is_removed"],
                                                    })
                                                );
                                            }
                                        })
                                        .catch((error: any) => {
                                            console.log("error", error);
                                        });
                                }}
                            >
                                <AppImages.iconTrash className="text-error w-5 h-5" />
                            </IconButton>
                        )}
                    </td>
                </tr>
                {task.subtasks &&
                    expandedRow === idx &&
                    task.subtasks.map((subtask: Task, subIdx: number) =>
                        renderRow(subtask, subIdx, "pl-[70px]")
                    )}
            </React.Fragment>
        );
    };

    return !vehicle ? (
        <Loader />
    ) : (
        <React.Fragment>
            <Card className={`p-2 md:p-5 ${selectedTask ? "h-[calc(100dvh-260px)]" : ""}`}>
                <Card.Header className="w-full m-0 items-start rounded-none flex flex-wrap gap-4 justify-between p-4">
                    <div>
                        <Typography type="lead" color="default" className="font-semibold mb-1">
                            Work Orders
                        </Typography>
                        <Typography type="small" className="text-foreground block">
                            View all the work orders for this vehicle.
                        </Typography>
                    </div>
                    <div className="flex flex-col sm:flex-row items-center w-full shrink-0 gap-3 md:w-max">
                        <Input placeholder="Search here..." className="w-full sm:w-72">
                            <Input.Icon>
                                <Search className="w-full h-full" />
                            </Input.Icon>
                        </Input>
                        <div className="flex gap-3 sm:w-max w-full">
                            <Button
                                variant="outline"
                                color="secondary"
                                className="flex items-center gap-2"
                            >
                                Filter
                                <Sort className="w-4 h-4" />
                            </Button>
                            <Button
                                variant="outline"
                                color="secondary"
                                className="flex items-center gap-2"
                            >
                                Export
                                <Download className="w-4 h-4" />
                            </Button>
                            {["SuperUser", "Admin"].includes(auth?.user?.role?.title || "") && (
                                <Button
                                    variant="outline"
                                    color="secondary"
                                className="flex items-center w-auto"
                                onClick={() => {
                                    dispatch(
                                        updateTasksRequest({
                                            vehicle_id: vehicle?.id,
                                            tasks: [
                                                ...(tasks || []),
                                                { name: "" },
                                            ] as unknown as Task[],
                                            update_fields: ["id", "name"],
                                            cb: (data: Task[]) => {
                                                setSelectedTask(data[data.length - 1]);
                                            }
                                        })
                                    );
                                }}
                            >
                                <Plus className="w-4 h-4" />
                                <Typography type="small" className="block text-primary text-nowrap">
                                    Add Task
                                    </Typography>
                                </Button>
                            )}
                        </div>
                    </div>
                </Card.Header>
                <Card.Body className="mt-4 p-0 rounded-none max-h-[calc(100vh-350px)] overflow-y-auto scrollbar-hide relative">
                    <table className="w-full min-w-max table-auto">
                        <thead>
                            <tr>
                                {TABLE_HEAD.map((el, idx: number) => (
                                    <th
                                        key={idx}
                                        className={`sticky top-0 bg-white z-10 border-b text-start border-surface p-4 ${el.className}`}
                                    >
                                        <Typography
                                            type="small"
                                            color="default"
                                            className="block font-medium"
                                        >
                                            {el.n}
                                        </Typography>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tasks.filter((el: Task) => !el.parent_task).map((el, idx: number) => renderRow(el, idx))}
                        </tbody>
                    </table>

                    {selectedTask && (
                        <TaskDetailsSidePanel
                            tasks={tasks}
                            selectedTask={selectedTask}
                            onClose={(task: Task) => {
                                setSelectedTask(null);
                                dispatch(updateTasksRequest({
                                    vehicle_id: vehicle?.id,
                                    tasks: [task],
                                    update_fields: [],
                                }));
                            }}
                        />
                    )}
                </Card.Body>
            </Card>
        </React.Fragment>
    );
}
